module.exports = __webpack_public_path__ + "assets/images/d611d563e53bd65f7971d0748f75d5f9.png";